import React from 'react';
import { Popover } from '@mui/material';
import LoginForm from './LoginForm';

interface LoginPopoverProps {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
}

const LoginPopover: React.FC<LoginPopoverProps> = ({ anchorEl, open, onClose }) => {
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            slotProps={{
                paper: {
                    sx: {
                        width: 360,
                        borderRadius: 2,
                        mt: 1,
                    },
                },
            }}
        >
            <LoginForm onLoginSuccess={onClose} />
        </Popover>
    );
};

export default LoginPopover;
